import { type ComponentProps } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { get } from 'lodash-es';
import TextField from '../components/TextField';

/** controlled by react-hook-form context
 *
 * TODO: update this to use the number format input
 */
const ControlledNumberField = ({
  name,
  ...inputProps
}: ComponentProps<typeof TextField> & { name: string }) => {
  const { control, errors } = useFormContext();
  const errorMessage = get(errors, name)?.message;

  return (
    <Controller
      control={control}
      name={name}
      render={({ ref, value = '', onChange, onBlur, name: controlledName }) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          onChange(e.target.value === '' ? 0 : e.target.valueAsNumber);
        };

        return (
          <TextField
            ref={ref}
            {...inputProps}
            errorMessage={errorMessage}
            name={controlledName}
            onBlur={onBlur}
            onChange={handleChange}
            value={value}
            type="number"
          />
        );
      }}
    />
  );
};
export default ControlledNumberField;
